<template>
  <div class="content">
    <LinkPath current-path="atualização de agentes"/>
    <section>
      <div class="row">
        <div class="col-md-12">
          <div class="box box-info">
            <div class="form-group">
              <form id="formBio" style="padding: 10px !important;">

                <div id="divAlert" class="alert alert-success" role="alert" style="margin: 16px; display:none;"></div>

                <div class="agent-input-group">
                  <div class="form-row">
                    <div class="col-md-4 mb-3">
                      <label for="cpf">CPF</label>
                      <input type="text" class="form-control cpf" id="cpf" v-model="cpf">
                    </div>
                  </div>
                  <div class="form-group pesquisa-box">
                    <div class="col-md-1 mb-3">
                      <button id="btnPesq" type="button" v-on:click="searchAgent()"
                              class="btn btn-primary search-button">
                        Pesquisar
                      </button>
                    </div>
                  </div>
                </div>

                <div style="clear:both;"></div>

              </form>
            </div>

            <div class="row center-block">
              <div class="col-md-12">
                <div class="box">

                  <!-- /.box-header -->
                  <div class="box-body">
                    <div id="divUserAgent">
                      <div class="dataTables_wrapper form-inline dt-bootstrap" id="tabUser_wrapper">
                        <div class="row">
                          <div class="col-sm-6">
                            <div id="tabUser_length" class="dataTables_length">

                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-sm-12 table-responsive">
                            <table aria-describedby="tabUser" role="grid" id="tabUser"
                                   class="table table-bordered table-striped dataTable">
                              <thead>
                              <tr role="row">
                                <th aria-sort="ascending" style="width: 167px;" colspan="1" rowspan="1"
                                    aria-controls="tabUser" tabindex="0" class="sorting_asc">Agente
                                </th>
                                <th style="width: 207px;" colspan="1" rowspan="1" aria-controls="tabUser" tabindex="0"
                                    class="sorting">Nome
                                </th>
                                <th style="width: 182px;" colspan="1" rowspan="1" aria-controls="tabUser" tabindex="0"
                                    class="sorting">Data de Cadastro
                                </th>
                                <th style="width: 182px;" colspan="1" rowspan="1" aria-controls="tabUser" tabindex="0"
                                    class="sorting">Cadastrado por
                                </th>
                                <th style="width: 182px;" colspan="1" rowspan="1" aria-controls="tabUser" tabindex="0"
                                    class="sorting">Data de Atualização
                                </th>
                                <th style="width: 182px;" colspan="1" rowspan="1" aria-controls="tabUser" tabindex="0"
                                    class="sorting">Status
                                </th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr v-for="(agent, index) in listaAgents" :key="agent.id" class="even" role="row">

                                <td class="sorting_1">{{ agent.agent.username }}</td>
                                <td>{{ agent.agent.name }}</td>
                                <td>{{ agent.createDateFormat }}</td>
                                <td>{{ agent.operator }}</td>
                                <td>{{ agent.updateDateFormat }}</td>
                                <td><a href="#"
                                              v-on:click="activeAgent(index); toggleClassByName('show', '#agentModal')"
                                              data-toggle="modal"
                                              data-target="#agentModal" title="Ativar/Inativar Update de Agente">{{agent.enabled ? "ATIVO" : "INATIVO"}}</a></td>
                              </tr>
                              </tbody>
                              <tfoot>
                              <tr>
                                <th colspan="1" rowspan="1">Agente</th>
                                <th colspan="1" rowspan="1">Nome</th>
                                <th colspan="1" rowspan="1">Data de Cadastro</th>
                                <th colspan="1" rowspan="1">Cadastrado por</th>
                                <th colspan="1" rowspan="1">Data de Atualização</th>
                                <th colspan="1" rowspan="1">Status</th>
                              </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.box-body -->
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="modal .collapse.show" id="agentModal" tabindex="-1" role="dialog" aria-labelledby="agentModalLabel"
           aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header agente-modal-header">
              <h4 class="modal-title" id="agentModalLabel" style="color: white; font-weight: bold;">Autorizar
                Atualização de Agente</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p style="font-size: 16px;">Deseja {{ enabled ? "desautorizar" : "autorizar" }} o agente de registro {{ agentName }} à efetuar sua
                atualização biométrica?</p>
              <br/>
              <div style="clear:both;"></div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
              <button type="button" v-on:click="updateAgent()" data-dismiss="modal" class="btn btn-danger">Sim</button>
            </div>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import $ from 'jquery'
import 'datatables.net'
import 'datatables.net-bs'
import interceptor from '../../interceptor'
import roles from '../../roles'
import LinkPath from '../components/LinkPath'

export default {
  name: 'AgentsUpdate',
  components: {LinkPath},
  data: function () {
    return {
      cpf: '',
      listaAgents: [],
      key: 'AGENTSUPT',
      agent: '',
      agentName: '',
      enabled: false
    }
  },
  methods: {
    toggleClassByName(className, id) {
      $(id).toggle(className)
    },
    check: function (action) {
      return roles.checkrole(window.localStorage.getItem('role'), this.key, action)
    },
    searchAgent: function () {
      $('#btnPesq').attr('disabled', true)
      $('#divUserAgent').hide()
      this.clear()
      if (this.cpf !== undefined && this.cpf !== '') {
        interceptor.request('get', 'api/v1/users/' + this.cpf + '/agent', {})
          .then(response => {
            if (response.data) {
              this.agent = response.data
              this.listaAgents = []
              this.listaAgents[0] = response.data
              this.refreshData()
              this.$nextTick(() => {
                $('#tabUser').DataTable({
                  'oLanguage': {
                    'sUrl': '/static/json/languageDataTable.json'
                  }
                })
              })
            }
          })
          .catch(function (error) {
            var msg = error.response.status
            if (msg === 404) {
              $('#divAlert').attr('class', 'alert alert-danger')
                .append('<p style="font-weight: bold;">Agente de registro não encontrado.</p>')
                .show()
            } else {
              $('#divAlert').attr('class', 'alert alert-danger')
                .append('<p style="font-weight: bold;">Erro ao tentar pesquisar. Serviço indisponível.</p>')
                .show()
            }
          })
      } else {
        this.listAgents()
      }
      $('#divUserAgent').show()
      setTimeout(() => $('#btnPesq').attr('disabled', false), 2000)
    },
    listAgents: function () {
      this.clear()
      interceptor.request('get', 'api/v1/users/agents', {})
        .then(response => {
          if (response.data) {
            this.listaAgents = response.data
            // Chama o Data Table passando o arquivo de tradução e o mesmo monta os filtros da tabela
            this.refreshData()
            this.$nextTick(() => {
              $('#tabUser').DataTable({
                'oLanguage': {
                  'sUrl': '/static/json/languageDataTable.json'
                }
              })
            })
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    activeAgent: function (index) {
      this.agent = this.listaAgents[index]
      this.agentName = this.agent.agent.name
      console.log('this.agent.enabled: ' + this.agent.enabled)
      this.enabled = this.agent.enabled
    },
    updateAgent: function () {
      let username = this.agent.agent.username
      let enabled = this.enabled
      console.log('enabled: ' + enabled)
      enabled = !enabled // to change status
      let operator = window.localStorage.getItem('usercod')
      interceptor.request('post', 'api/v1/auth/agent', {username, operator, enabled})
        .then(response => {
          $('#divAlert').attr('class', 'alert alert-success')
            .append('<p style="font-weight: bold;">Registro atualizado com sucesso.</p>')
            .show()
        })
        .catch(function (error) {
          var msg = error.response.status
          if (msg === 404) {
            $('#divAlert').attr('class', 'alert alert-danger')
              .append('<p style="font-weight: bold;">Método não encontrado.</p>')
              .show()
          } else {
            $('#divAlert').attr('class', 'alert alert-danger')
              .append('<p style="font-weight: bold;">Erro ao tentar atualizar os dados. Serviço indisponível.</p>')
              .show()
          }
        })
      setTimeout(() => location.reload(), 1000)
    },
    drawDT() {
      $('#tabUser').DataTable().draw()
    },
    async refreshData() {
      this.isLoading = true
      $('#tabUser').DataTable().destroy()
      try {
        await this.$nextTick(this.drawDT)
      } catch (err) {
        console.error(err)
      } finally {
        this.isLoading = false
      }
    },
    clear: function () {
      $('#divAlert').empty().hide()
      this.listaAgents = []
      this.refreshData()
    }
  },
  mounted() {
    this.listAgents()
  }
}

</script>

<style>
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}

@-webkit-keyframes v-gridStretchDelay {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.5);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes v-gridStretchDelay {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.5);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>




// WEBPACK FOOTER //
// AgentsUpdate.vue?65b438ca